module.exports = __webpack_public_path__ + "img/28.baea69c4.jpg";